import script from "./OnlineMessageTextContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnlineMessageTextContent.vue?vue&type=script&lang=ts&setup=true"

import "./OnlineMessageTextContent.vue?vue&type=style&index=0&id=43947a38&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43947a38"]])

export default __exports__